((Drupal) => {
  const equalizeHeights = (context) => {
    const elements = context.querySelectorAll(".js-equalize-heights");

    elements.forEach((container) => {
      const equalizeSelector = container.getAttribute(
        "data-equalize-heights-selector"
      );
      const items = context.querySelectorAll(equalizeSelector);

      if (items.length === 0) return;

      // Reset any previously set min-height
      items.forEach((item) => (item.style.minHeight = ""));

      // Find the maximum height
      const maxHeight = Array.from(items).reduce((max, item) => {
        return Math.max(max, item.offsetHeight);
      }, 0);

      // Set the min-height to the tallest element’s height
      items.forEach((item) => (item.style.minHeight = `${maxHeight}px`));
    });
  };

  Drupal.behaviors.equalizeHeights = {
    attach(context) {
      equalizeHeights(context);
    },
  };
})(Drupal);
